import React from "react";

function Loader({ showLoading = false }) {
  return (
    <div id="preloader" className="blobs-wrapper">
      <div className="loader-blob"></div>
      {showLoading && <span>Loading...</span>}
    </div>
  );
}

export default Loader;
